import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PageHeader from "@/components/common/PageHeader";
import { MagnifyingGlass } from "@phosphor-icons/react";

const MODULES = ["", "participants", "uploads", "imports", "milestones", "risk", "bali", "crm", "users", "system"];

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [module, setModule] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (module) params.module = module;
      const { data } = await api.get("/audit-logs", { params });
      setRows(data);
    } catch {}
    setLoading(false);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [module]);

  return (
    <div className="p-6 md:p-8 max-w-[1600px] mx-auto">
      <PageHeader title="Audit Log" subtitle="Every important action across the system." breadcrumbs="Operations / Audit" testId="audit-page" />

      <div className="flex gap-2 mb-4">
        {MODULES.map((m) => (
          <button key={m || "all"} data-testid={`audit-filter-${m || "all"}`} onClick={() => setModule(m)} className={`px-3 py-1.5 text-xs rounded-md border ${module === m ? "bg-blue-500/10 border-blue-500 text-blue-300" : "border-white/10 text-gray-400 hover:text-white"}`}>
            {m || "All"}
          </button>
        ))}
      </div>

      <div className="bg-[#111827] border border-white/10 rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-white/10 bg-[#1F2937]/50 text-left text-[10px] uppercase tracking-widest text-gray-500">
                <th className="px-4 py-3">Timestamp</th>
                <th className="px-4 py-3">User</th>
                <th className="px-4 py-3">Action</th>
                <th className="px-4 py-3">Module</th>
                <th className="px-4 py-3">Participant</th>
                <th className="px-4 py-3">Notes</th>
              </tr>
            </thead>
            <tbody>
              {loading ? <tr><td colSpan={6} className="p-8 text-center text-gray-500">Loading…</td></tr> :
                rows.length === 0 ? <tr><td colSpan={6} className="p-8 text-center text-gray-500">No audit events</td></tr> :
                rows.map((r) => (
                  <tr key={r.id} data-testid={`audit-row-${r.id}`} className="border-b border-white/5 hover:bg-white/[0.02]">
                    <td className="px-4 py-3 text-xs font-mono text-gray-400 whitespace-nowrap">{(r.timestamp || "").slice(0, 19).replace("T", " ")}</td>
                    <td className="px-4 py-3 text-xs">
                      <p className="text-white">{r.user_name || "system"}</p>
                      <p className="text-gray-500">{r.user_email}</p>
                    </td>
                    <td className="px-4 py-3 text-sm text-orange-300 font-mono">{r.action}</td>
                    <td className="px-4 py-3 text-xs text-gray-400 capitalize">{r.module}</td>
                    <td className="px-4 py-3 text-xs font-mono text-gray-400">{(r.participant_id || "").slice(0, 8)}</td>
                    <td className="px-4 py-3 text-xs text-gray-400 max-w-md truncate">{r.notes || "—"}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
